import script from "./NameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NameInput.vue?vue&type=script&setup=true&lang=ts"

import "./NameInput.vue?vue&type=style&index=0&id=0dda1fd6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dda1fd6"]])

export default __exports__